import Icon from '@ant-design/icons';
import { Layout, Space } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { SVGTemplate, SVGFlow, SVGMachine } from '../../images';
import { StyledMenu } from './styles';

const Knowledge = () => {
  const { t } = useTranslation();
  const menus = [
    {
      key: 'template',
      label: t('template'),
      title: t('template'),
      icon: (
        <Space direction="vertical" size={0} className="menu-custom-icon">
          <Icon component={SVGTemplate} />
          <span className="menu-custom-title">{t('template')}</span>
        </Space>
      ),
    },
    {
      key: 'machine',
      label: t('machine'),
      title: t('machine'),
      icon: (
        <Space direction="vertical" size={0} className="menu-custom-icon">
          <Icon component={SVGMachine} />
          <span className="menu-custom-title">{t('machine')}</span>
        </Space>
      ),
    },
    {
      key: 'flow',
      label: t('flow_coming_soon'),
      title: t('flow'),
      icon: (
        <Space direction="vertical" size={0} className="menu-custom-icon">
          <Icon component={SVGFlow} />
          <span className="menu-custom-title">{t('flow')}</span>
        </Space>
      ),
    },
  ];
  const location = useLocation();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const { pathname } = location;

  const selectedKeys = pathname.split('/').slice(2);

  const [defaultOpenKeys, setDefaultOpenKeys] = useState<string[]>([]);

  return (
    <Layout style={{ height: '100%' }}>
      <Layout.Sider style={{ backgroundColor: '#3d5727' }} width={80}>
        <StyledMenu
          selectedKeys={selectedKeys}
          defaultOpenKeys={defaultOpenKeys}
          theme="light"
          // mode="inline"
          inlineCollapsed
          items={menus}
          onClick={({ key, keyPath }) => {
            navigate(key);
            setDefaultOpenKeys(keyPath);
          }}
        />
      </Layout.Sider>
      <Layout.Content>
        <Outlet />
      </Layout.Content>
    </Layout>
  );
};

export default Knowledge;
